import { render, staticRenderFns } from "./ModalDocumento.vue?vue&type=template&id=83d84698&scoped=true"
import script from "./ModalDocumento.vue?vue&type=script&lang=js"
export * from "./ModalDocumento.vue?vue&type=script&lang=js"
import style0 from "./ModalDocumento.vue?vue&type=style&index=0&id=83d84698&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83d84698",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('83d84698')) {
      api.createRecord('83d84698', component.options)
    } else {
      api.reload('83d84698', component.options)
    }
    module.hot.accept("./ModalDocumento.vue?vue&type=template&id=83d84698&scoped=true", function () {
      api.rerender('83d84698', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/cotejo/infoBase/modales/ModalDocumento.vue"
export default component.exports